<template>

  <section class="contact section" id="contact">

<!--     <div class="container location-wrapper">
      <h6 class="location-title">hecho en Colchagua</h6>
    </div> -->

    <div class="container contact-block">
        <div class="row">

            <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 content-header">
                 <h6 class="page-title stage-one">Let's talk</h6> <span class="red-line hidden-sm-down"></span>
                <a class="stage-two sys-ops-fo" href="mailto:hey@hackdagio.xyz">hey@hackdagio.xyz</a>
                <br />

<!--                 <a class="stage-four but-not-kinda-visible" target="_blank" href="https://t.me/hackdagio"><small>también en telegram con el username</small> @hackdagio <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.847 20.847" xml:space="preserve" class="hiper-icon hiper-telegram">
                            <path d="M0.4,10.6l5.8,2.2L8.4,20c0.1,0.4,0.5,0.6,0.8,0.5c0.1,0,0.2-0.1,0.2-0.1l3.2-2.6c0.3-0.3,0.8-0.3,1.2,0
  l5.8,4.2c0.4,0.3,1,0.1,1.1-0.4L25,0.8c0.1-0.5-0.4-1-0.9-0.8L0.4,9.3C-0.1,9.5-0.1,10.3,0.4,10.6L0.4,10.6z M8.1,11.6l11.3-7
  c0.2-0.1,0.4,0.2,0.2,0.3l-9.3,8.7c-0.3,0.3-0.5,0.7-0.6,1.2l-0.3,2.4c0,0.3-0.5,0.3-0.6,0l-1.2-4.3C7.4,12.4,7.6,11.8,8.1,11.6
  L8.1,11.6z" />
                        </svg></a> -->



            </div>

        </div>
    </div>

  </section>

</template>

<script>
export default {
  name: 'Features',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style scoped>

section.contact {
  position: relative;
  background: url('/static/img/hero.jpg') center center no-repeat;
  background-size: cover;
  color: white;
  overflow: hidden;
  min-height:500px;
}

@media all and (min-width: 768px) {
  section.contact:hover .contact-block .stage-four {
  opacity: 0.5;
  }
}


section.contact:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: scale(1.1);
  background-image: linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0,0.9) 70%,rgba(0,0,0,1) 100%), linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 40%,rgba(0,0,0,1) 90%);
}

@media all and (max-width: 768px) {
  section.contact:before {

    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.7) 40%,rgba(0,0,0,1) 100%);
  }

  .contact-block {
    text-align: center;
    margin-top: 30vh;
  }

  .contact-block .red-line {opacity: 0}
}

.contact-block .stage-one {
    color: #f9a743;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: normal;
  font-family: 'ClanWebPro';
}

.contact-block .red-line {
  display: block;
  width: 30px;
  height: 2px;
  margin: 10px 0 20px;
  background-color: #f9a743;
  transition: all .2s linear;
  width: 4em;
  margin: 2vw 0 2vw 0;
}

.contact-block .stage-two {
    font-weight: lighter;
    color: white;
    margin-bottom: 6px;
    text-shadow: 0px 0px 10px black;
    text-transform: lowercase;
    font-size: 2.7rem;
}

.contact-block .stage-four {
    font-weight: lighter;
    color: white;
    opacity: 0;
    margin-bottom: 6px;
    text-shadow: 0px 0px 10px black;
    text-transform: lowercase;
    font-size: 1.4rem;
}



.contact-block .stage-four small {
  font-size: 0.8rem;
}

.contact-block .txt {
    display: inline;
}
.contact-block .txt a {
    color: white;
    font-weight: lighter;
    text-shadow: 0px 0px 10px black;
}

.location-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: right;

}

.location-wrapper .location-title {
  text-transform: uppercase;
  font-weight: lighter;
  letter-spacing: .6em;
  margin-top: 1em;
  color: #ffcc43;
  text-shadow: 0px 0px 10px black, 0px 0px 10px black, 0px 0px 10px black, 0px 0px 10px black;
  opacity: 0.6;
  transition: all 250ms ease-in-out;
}

.location-wrapper .location-title:hover {
  opacity: 1;
}

@media all and (max-width: 768px) {
  .location-wrapper .location-title {
    writing-mode: vertical-lr;
    float: right;
    margin-top: 5vh;

    opacity: 1;
  }

  .contact-block .stage-two {
    font-size: 1.5rem;
  }

  .contact-block .stage-four {
    opacity: 0.5;
  }
}

.hiper-icon {
    display: inline-block;
    vertical-align: middle;
    width: 1em;
    height: auto;
    fill: white;
    margin: 0 4px;
    opacity: 1;
}


.link-with-icon {
  display: inline-flex;
justify-content: flex-start;
align-items: center;
flex-direction: row;
}

.new-stuff-kinda-button
{
  background:orange;
  border-radius: 2em;
  padding: .5em 1em;
  font-size:50%;
  color: black;
  opacity: 0.6;
}

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue